import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCompanyConfigQuery } from "../../SWR/Company/useCompanyConfigQuery";
/** * @deprecated Use `useCurrencyLocalizer()` instead. */
export const LocalizedCurrencyText = ({ value }) => {
    const { culture } = useCompanyConfigQuery();
    const numberFormat = new Intl.NumberFormat(culture.cultureInfo, {
        style: "currency",
        currency: culture.currency,
    });
    return _jsx(_Fragment, { children: numberFormat.format(value) });
};
